// eslint-disable-next-line import/prefer-default-export
export const AppRoutes = {
  EXPLORE: {
    path: '/',
    name: 'Explore',
    meta: {
      requiresAuth: true,
      fullName: 'Explore Page',
    },
  },
  MY_DOCS: {
    path: '/my-docs',
    name: 'MyDocs',
    meta: {
      requiresAuth: true,
      fullName: 'My Docs Page',
    },
  },
  MIGRATED_DOCS: {
    path: '/migrated-docs',
    name: 'MigratedDocs',
    title: 'My Migrated Docs Page',
    meta: {
      requiresAuth: true,
      fullName: 'My Migrated Docs Page',
    },
  },
  QUESTIONNAIRE: {
    path: '/questionnaire',
    name: 'Questionnaire',
    title: 'Questionnaire Page',
    meta: {
      requiresAuth: true,
      fullName: 'Questionnaire Page',
    },
  },
  DISCLAIMER: {
    path: '/disclaimer',
    name: 'Disclaimer',
    title: 'Disclaimer Page',
    meta: {
      hasFooter: false,
      fullName: 'Disclaimer Page',
    },
  },
  PRIVACY_POLICY: {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    title: 'Privacy Policy Page',
    meta: {
      hasFooter: false,
      fullName: 'Privacy Policy Page',
    },
  },
  TERMS_AND_CONDITIONS: {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    title: 'Terms and Conditions Page',
    meta: {
      hasFooter: false,
      fullName: 'Terms and Conditions Page',
    },
  },
  dynamic: {
    questionnaireByRecordId: (id: string) => `/questionnaire?record_id=${id}`,
    questionnaireByDocumentId: (id: string) => `/questionnaire?document_id=${id}`,
    questionnaireClipboardDocument: (id: string) => `${window.location.origin}/questionnaire?document_id=${id}`,
  },
};
